// Central legal-entity metadata for MediaOthers.
// All values are read from environment variables so ops can update KvK/VAT
// without touching the codebase. Empty fallback strings render as "—" on the
// legal pages until the operator populates them.
//
// IMPORTANT: `process.env.REACT_APP_*` must be referenced literally — Webpack's
// DefinePlugin only substitutes exact string matches at build time.

export const LEGAL = {
  company: process.env.REACT_APP_LEGAL_COMPANY || "QOthers",
  brand: "MediaOthers",
  country: process.env.REACT_APP_LEGAL_COUNTRY || "Netherlands",
  kvk: process.env.REACT_APP_LEGAL_KVK || "",
  establishment: process.env.REACT_APP_LEGAL_ESTABLISHMENT || "",
  vat: process.env.REACT_APP_LEGAL_VAT || "",
  email: process.env.REACT_APP_LEGAL_EMAIL || "info@mediaothers.com",
  effectiveDate: process.env.REACT_APP_LEGAL_EFFECTIVE || "22 February 2026",
};

/** Human-friendly fallback when a field hasn't been populated yet. */
export const asDash = (v) => (v && String(v).trim().length ? v : "—");
